/**
 * One missed card in a lesson's, a round's or an exam's end list (v1 ticket
 * 24): the card's line in the interface's direction and its answer isolated
 * in its own, with the arrow between them pointing the way the interface reads.
 */
import { html, nothing } from 'lit';
import { iso, onGlyph, tPart, ui, uiDir } from '../bidi-html';

export function missedRow(m: { label: string; expected: string; explain?: string; disputed?: boolean; given?: string }) {
  return html`<div class="small missed-row" style="margin-top:6px" dir=${ui()}>• <bdi dir=${uiDir(m.label)}>${iso(m.label)}</bdi> ${onGlyph()} <bdi class="ca" dir="auto">${m.expected}</bdi>
    ${m.explain ? html`<div class="muted small" dir=${uiDir(m.explain)}>${iso(m.explain)}</div>` : nothing}
    ${m.disputed ? html`<div class="muted small" dir=${ui()}>${tPart('lesson.flagged', 'given', html`<bdi dir="auto">${m.given ?? ''}</bdi>`)}</div>` : nothing}
  </div>`;
}
